// extracted by css-extract-rspack-plugin
export default {"sectionIcon":"sectionIcon-RsH7nN","skillsList":"skillsList-lOi7Xi","section":"section-_kHy1y"};